const protocols = [
  { name: 'FIDO2 / WebAuthn', status: 'CERTIFIED' },
  { name: 'FIDO U2F', status: 'CERTIFIED' },
  { name: 'Smart Card (PIV)', status: 'SUPPORTED' },
  { name: 'OpenPGP', status: 'SUPPORTED' },
]

const cryptoStandards = [
  { name: 'RSA 2048/4096', description: 'Public key crypto' },
  { name: 'ECC P256/P384', description: 'Elliptic curve' },
  { name: 'HMAC-SHA1/SHA256', description: 'Hash functions' },
  { name: 'AES-128/256', description: 'Symmetric encryption' },
]

function TechSpecs() {
  return (
    <div className="bg-white rounded-2xl border border-gray-200 overflow-hidden">
      <div className="px-8 py-4 border-b border-gray-200">
        <h3 className="text-2xl font-bold text-gray-900 mb-2">Technical Specifications</h3>
        <p className="text-gray-600">YubiKey 5 Series - Gold standard for authentication</p>
      </div>
      <div className="p-6">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
          {/* Authentication Protocols */}
          <div>
            <h4 className="font-bold text-gray-900 mb-4 flex items-center gap-2">
              <i className="iconoir-shield text-yubico-green-400"></i>
              Authentication Protocols
            </h4>
            <div className="space-y-2">
              {protocols.map((protocol, i) => (
                <div
                  key={protocol.name}
                  className={`flex items-center justify-between py-2 ${i < protocols.length - 1 ? 'border-b border-gray-100' : ''
                    }`}
                >
                  <span className="font-mono text-sm text-gray-600">{protocol.name}</span>
                  <span className="text-xs text-yubico-green-500 font-bold flex items-center gap-1">
                    <i className="iconoir-check-circle text-yubico-green-500 text-sm"></i>
                    {protocol.status}
                  </span>
                </div>
              ))}
            </div>
          </div>

          {/* Cryptographic Standards */}
          <div>
            <h4 className="font-bold text-gray-900 mb-4 flex items-center gap-2">
              <i className="iconoir-lock text-yubico-green-400"></i>
              Cryptographic Standards
            </h4>
            <div className="space-y-2">
              {cryptoStandards.map((standard, i) => (
                <div
                  key={standard.name}
                  className={`flex items-center justify-between py-2 ${i < cryptoStandards.length - 1 ? 'border-b border-gray-100' : ''
                    }`}
                >
                  <span className="font-mono text-sm text-gray-600">{standard.name}</span>
                  <span className="text-xs text-gray-500">{standard.description}</span>
                </div>
              ))}
            </div>
          </div>
        </div>

        {/* Secure Element Info */}
        <div className="mt-6 p-4 bg-yubico-green-50 rounded-xl border border-yubico-green-200">
          <div className="flex items-start gap-4">
            <i className="iconoir-info-circle text-yubico-green-500 text-3xl"></i>
            <div>
              <h5 className="font-bold text-gray-900 mb-2">Secure Element</h5>
              <p className="text-sm text-gray-700 leading-relaxed">
                YubiKeys use tamper-resistant secure elements to store cryptographic keys.
                Private keys never leave the device&mdash;making them immune to remote attacks,
                phishing, and credential theft.
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default TechSpecs
